"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)({
    display: 'inline-block',
    minHeight: '24px',
    lineHeight: '24px',
    padding: '0px 12px',
    textAlign: 'center',
    outline: 'none',
    border: 'none',
    borderRadius: '12px',
    fontSize: '14px',
    color: 'white',
    backgroundColor: theme.primary,
    '& > span': {
      paddingLeft: '5px'
    },
    '&:focus': {
      textDecoration: 'underline'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:default;"),
  neutral: theme => /*#__PURE__*/(0, _react.css)({
    color: theme.defaultText,
    backgroundColor: theme.gray20
  }, process.env.NODE_ENV === "production" ? "" : ";label:neutral;"),
  success: theme => /*#__PURE__*/(0, _react.css)({
    color: theme.defaultText,
    backgroundColor: theme.successMedium
  }, process.env.NODE_ENV === "production" ? "" : ";label:success;"),
  info: theme => /*#__PURE__*/(0, _react.css)({
    color: theme.bgDark,
    backgroundColor: theme.infoMedium
  }, process.env.NODE_ENV === "production" ? "" : ";label:info;"),
  danger: theme => /*#__PURE__*/(0, _react.css)({
    color: 'white',
    backgroundColor: theme.alert
  }, process.env.NODE_ENV === "production" ? "" : ";label:danger;"),
  dark: theme => /*#__PURE__*/(0, _react.css)({
    color: 'white',
    backgroundColor: theme.bgDark
  }, process.env.NODE_ENV === "production" ? "" : ";label:dark;"),
  light: theme => /*#__PURE__*/(0, _react.css)({
    color: theme.bgDark,
    backgroundColor: theme.bgLight
  }, process.env.NODE_ENV === "production" ? "" : ";label:light;"),
  outline: theme => /*#__PURE__*/(0, _react.css)("color:", theme.defaultText, ";min-height:20px;line-height:20px;border:2px solid ", theme.bgLight, ";background-color:white;" + (process.env.NODE_ENV === "production" ? "" : ";label:outline;")),
  dotted: theme => /*#__PURE__*/(0, _react.css)("color:", theme.defaultText, ";min-height:20px;line-height:20px;border:2px dotted ", theme.border, ";background-color:transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:dotted;")),
  withclose: process.env.NODE_ENV === "production" ? {
    name: "aymhac",
    styles: "display:flex;align-items:center;min-height:24px;line-height:unset;&>svg{margin-left:0.5em;}"
  } : {
    name: "1eravii-withclose",
    styles: "display:flex;align-items:center;min-height:24px;line-height:unset;&>svg{margin-left:0.5em;};label:withclose;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  strictClose: process.env.NODE_ENV === "production" ? {
    name: "sqodq5",
    styles: "display:flex;width:fit-content;align-items:center;min-height:24px;line-height:unset;&>button{margin-left:0.5em;}"
  } : {
    name: "v4s7sa-strictClose",
    styles: "display:flex;width:fit-content;align-items:center;min-height:24px;line-height:unset;&>button{margin-left:0.5em;};label:strictClose;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  loading: process.env.NODE_ENV === "production" ? {
    name: "10i8va3",
    styles: "display:flex;width:fit-content;align-items:center;min-height:24px;line-height:unset;gap:0.5em;&>div{margin-right:0.5em;}"
  } : {
    name: "10cwrar-loading",
    styles: "display:flex;width:fit-content;align-items:center;min-height:24px;line-height:unset;gap:0.5em;&>div{margin-right:0.5em;};label:loading;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  withicon: process.env.NODE_ENV === "production" ? {
    name: "uoujw6",
    styles: "display:flex;align-items:center;gap:5px;width:fit-content"
  } : {
    name: "4g9093-withicon",
    styles: "display:flex;align-items:center;gap:5px;width:fit-content;label:withicon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _default = exports.default = styles;